import { render, staticRenderFns } from "./HiddenField.form-builder.vue?vue&type=template&id=04f23b68&"
import script from "./HiddenField.form-builder.vue?vue&type=script&lang=js&"
export * from "./HiddenField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports